// Polyfill
import "babel-polyfill";
require("babel-runtime/core-js/promise").default = require("bluebird");
require("promise.prototype.finally").shim();
import "whatwg-fetch";

import React from "react";
import ReactDom from "react-dom";

import injectTapEventPlugin from "react-tap-event-plugin";

import AppRoot from "./app-root.jsx";

// Styling for required modules
import "./app.css";

// Logging
import "./logger";

// Moment setup
import moment from "moment";
moment.locale("en");

// Moment two-digit year parsing setup
const centuryCutoff = (new Date().getFullYear() % 1000) + 5;
moment.parseTwoDigitYear = yearString => {
  return (
    parseInt(yearString) + (parseInt(yearString) > centuryCutoff ? 1900 : 2000)
  );
};

// Disable scrolling on number fields
document.addEventListener("wheel", function (e) {
  if (
    e.target.tagName.toLowerCase() === "input" &&
    e.target.type === "number" &&
    e.target === document.activeElement &&
    !e.target.readOnly
  ) {
    e.target.readOnly = true;
    setTimeout(() => {
      e.target.readOnly = false;
    }, 0);
  }
});

// Stripe setup
if (!window.Stripe) {
  window.Stripe = { setPublishableKey: () => {} };
}
Stripe.setPublishableKey(process.env.STRIPE_PUBLIC_KEY);

// Heap setup
heap.load(process.env.HEAP_APP_ID);

//Needed for React Developer Tools
window.React = React;

//Needed for onTouchTap
//https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

ReactDom.render(<AppRoot />, document.getElementById("app"));

// Hide loader
document.getElementById("loader").style.display = "none";



// WEBPACK FOOTER //
// ./src/app/app.jsx